module.exports = __webpack_public_path__ + "static/media/1.cd5eaa97.jpg";